<section>
  <div class="row g-3">
    <div class="col-12">
      <div class="sana-card">
        <a
          class="back-hint"
          role="link"
          [routerLink]="['../exercises']"
          tabindex="0">
          <i class="pi pi-chevron-left"></i> Zurück zu den Übungen
        </a>

        @if (isClientLoaded()) {
          <ng-container [ngTemplateOutlet]="content"></ng-container>
        } @else {
          <sana-tp-sekeleton-loading></sana-tp-sekeleton-loading>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #content>
  <sana-tp-add-therapy-plan-data></sana-tp-add-therapy-plan-data>
</ng-template>
